module.exports = __webpack_public_path__ + "static/media/pk.a7fc6144.svg";